//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowContract(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.2426 10.8995L8 6.65685V3.82843L11.2456 7.07405L11.2385 2H13.2467L13.2397 7.07405L16.4853 3.82843V6.65685L12.2426 10.8995Z" fill="currentColor" /><path d="M12.2426 13L8 17.2426V20.0711L11.2456 16.8254L11.2385 21.8995H13.2467L13.2397 16.8254L16.4853 20.0711V17.2426L12.2426 13Z" fill="currentColor" /></svg>;
}
export default IconArrowContract;